import {
    Card, Grid
} from "@mui/material";
import { generateUnitCountPDFApi, getReportUnitCountApi } from 'api/report'; // API fonksiyonlarını import et
import ReportFilterCard from "app/components/Card/report/ReportFilterCard";
import ReportUnitCountTable from "app/components/Table/reports/ReportUnitCountTable";
import React, { useState } from "react";

const ReportUnitCountPage = () => {
    const [data, setData] = useState([]);
    const [lastFilter, setLastFilter] = useState(null);

    const setFilterData = (data) => {
        setData(data);
    };

    // UnitCount için özel handleResultList fonksiyonu
    const handleResultListUnitCount = async (filters) => {
        try {
            const res = await getReportUnitCountApi(filters);
            const responseData = res.data;
            setFilterData(responseData.data);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        }
    };

    // UnitCount için özel PDF fonksiyonu
    const generateUnitCountPDF = async () => {
        if (!lastFilter) return;
        try {
            await generateUnitCountPDFApi(lastFilter);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <React.Fragment>
            <Grid container sx={{ marginBottom: 4 }}>
                <Grid item xs={12} md={12}>
                    <ReportFilterCard
                        title="Kurul/Kol/Komisyonların Toplantı Sayısı"
                        setFilterData={setFilterData}

                        handleResultList={handleResultListUnitCount}
                        generatePDFApi={generateUnitCountPDF}
                        showUnitFilter={false} // Unit filtresini gizle
                    />
                </Grid>
            </Grid>

            {data.length > 0 && (
                <Card sx={{ padding: 2 }}>
                    <ReportUnitCountTable data={data} />
                </Card>
            )}
        </React.Fragment>
    );
};

export default ReportUnitCountPage;

